<template>
  <div id="geo" class="franchise-geo mt-110">
    <div class="franchise-geo-background" />
    <div class="public-container public-container-mobile flex flex-center">
      <div class="franchise-geo-main">
        <div class="franchise-geo-main-wrapper">
          <vz-icon
            name="map-marker"
            variant="primary"
            size="28"
            class="franchise-geo-main-marker mr-10"
          />
          <div class="franchise-geo-main-info">
            <h2 class="color-primary">{{ data.title }}</h2>
            <div class="text-medium mt-10">{{ data.description }}</div>
            <NuxtImg src="/images/pages/franchise/geo.png" class="mt-40" alt="" format="webp" loading="lazy" />
          </div>
        </div >
      </div>
      <div class="franchise-geo-cities">
        <div class="franchise-geo-cities-wrapper">
          <region-cities 
            is-locations-links-empty 
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RegionCities from '~~/components/public/region-cities/region-cities.vue'
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/franchise')).blocks?.geo
</script>
